import { IResetPasswordForm } from '../pages/resetPasswordPage/resetPasswordInterface';
import { post } from './apiService';

export const resetPassword = async (data: IResetPasswordForm) => {
  return await post('/auth/reset-password', data);
};
